import {
  CertificationButton,
  type Props as CertificationButtonProps,
} from './certification-button'
import {
  type PhoneVerificationResult,
  useGetPhoneNumber,
} from '../api/get-phone-number'

type Props = Omit<CertificationButtonProps, 'onSuccess'> & {
  onSuccess?: ({ certNum, phoneNumber }: PhoneVerificationResult) => void
}

export const PhoneVerificationButton = ({ onSuccess, ...restProps }: Props) => {
  const { getPhoneNumber } = useGetPhoneNumber({
    onSuccess: ({ certNum, phoneNumber }) => {
      onSuccess?.({ certNum, phoneNumber })
    },
  })

  const handleCertificationSuccess = (certNum: string) => {
    getPhoneNumber(certNum)
  }

  return (
    <CertificationButton
      onSuccess={handleCertificationSuccess}
      {...restProps}
    />
  )
}
